import { IsIn, IsNotEmpty } from 'class-validator';

import { FILTER_TYPES_KEYS, FilterType } from './consts';

export class Filter {
  @IsNotEmpty()
  name!: string;

  @IsNotEmpty()
  id!: string;

  @IsIn(FILTER_TYPES_KEYS)
  type!: FilterType;

  ruleFieldProps?: any;
}
